import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ICancellationPolicy,
  ICancellationPolicyInitialState,
} from "./cancellationpolicyModel";
import {
  ActiveInactiveCancellationPolicy,
  createCancellationPolicy,
  deleteCancellationPolicy,
  getAllActiveCancellationPolicy,
  getAllCancellationPolicy,
  getCancellationPolicyByID,
  updateCancellationPolicy,
} from "./services/cancellationpolicy.services";

const initialState: ICancellationPolicyInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  CancellationPolicyList: [],
  CancellationPolicyID: null,
  CancellationPolicyDetail: {
    Title: "",
    Description: "",
    IsActive: 1,
  },
};

const cancellationpolicySlice = createSlice({
  name: "cancellationpolicy",
  initialState,
  reducers: {
    clearCancellationPolicyDetails: (state) => {
      state.CancellationPolicyDetail = initialState.CancellationPolicyDetail;
    },
    setCancellationPolicyID: (state, action) => {
      state.CancellationPolicyID = action.payload;
    },
    clearCancellationPolicyID: (state) => {
      state.CancellationPolicyID = initialState.CancellationPolicyID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCancellationPolicy.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCancellationPolicy.fulfilled,
      (state, action: PayloadAction<ICancellationPolicy[]>) => {
        state.loading = false;
        state.CancellationPolicyList = action.payload || [];
      }
    );
    builder.addCase(getAllCancellationPolicy.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CancellationPolicyList = [];
    });
    builder.addCase(createCancellationPolicy.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createCancellationPolicy.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createCancellationPolicy.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCancellationPolicy.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateCancellationPolicy.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateCancellationPolicy.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCancellationPolicy.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCancellationPolicy.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCancellationPolicy.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCancellationPolicyByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(
      getCancellationPolicyByID.fulfilled,
      (state, action: any) => {
        state.formLoading = false;
        state.CancellationPolicyDetail = action.payload;
      }
    );
    builder.addCase(getCancellationPolicyByID.rejected, (state, action) => {
      state.formLoading = false;
      state.CancellationPolicyDetail = initialState.CancellationPolicyDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCancellationPolicy.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCancellationPolicy.fulfilled,
      (state, action: PayloadAction<ICancellationPolicy[]>) => {
        state.loading = false;
        state.CancellationPolicyList = action.payload || [];
      }
    );
    builder.addCase(
      getAllActiveCancellationPolicy.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.CancellationPolicyList = [];
      }
    );
    builder.addCase(ActiveInactiveCancellationPolicy.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveCancellationPolicy.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      ActiveInactiveCancellationPolicy.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );
  },
});

export const {
  clearCancellationPolicyDetails,
  clearCancellationPolicyID,
  setCancellationPolicyID,
} = cancellationpolicySlice.actions;
export default cancellationpolicySlice.reducer;
